import { Component } from '@angular/core';
import { url } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {

  navigateTo(direction: string): string {
    return '/' + url['lista-perfiles'] + '/' + direction;
  }

}
